/*
 * Public API Surface of form-tab
 */

export * from './lib/form-tab.service';
export * from './lib/form-tab.component';
export * from './lib/form-tab.module';
